/* eslint-disable sort-keys */
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import {
  CnuMaintenancePage,
  CnuMessageCenter,
  CnuMessageDetail,
} from '@consumer-frontend/components';
import { useFeatureFlag } from '@consumer-frontend/optimizely';

import { ErrorPage } from './ErrorPage';
import { HomePage } from './HomePage';
import { RootPage } from './RootPage';

const GenericErrorPage = () => <ErrorPage message="Whoops, something went wrong. Please try again." />;

export const App = () => {
  const { enabled, isLoading } = useFeatureFlag('cnu_maintenance');

  // Nothing renders until the decision lands, so the app never flashes before
  // being replaced by the maintenance page.
  if (isLoading) {
    return null;
  }

  // Returning before createBrowserRouter is what makes this cover every route,
  // including the '*' catch-all and both errorElements.
  if (enabled) {
    return <CnuMaintenancePage />;
  }

  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootPage />,
      errorElement: GenericErrorPage(),
      children: [
        {
          errorElement: GenericErrorPage(),
          children: [
            {
              path: '',
              index: true,
              element: <HomePage />,
            },
            {
              path: '/messages',
              element: <CnuMessageCenter />,
            },
            {
              path: '/message-detail',
              element: <CnuMessageDetail />,
            },
            {
              path: '*',
              element: <ErrorPage message="Sorry, but the page you're looking for can't be found." />,
            },
          ],
        },
      ],
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
};
